"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _notification = require("@widget/notification");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _List = _interopRequireDefault(require("./List"));

var _defaultsModule = _interopRequireDefault(require("./defaults.module.scss"));

function Notifications(_ref) {
  var onViewAll = _ref.onViewAll;

  try {
    var handleViewAll = function handleViewAll() {
      onViewAll && onViewAll();
    };

    var items = (0, _reactRedux.useSelector)(_notification.selectItems);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['list']
    }, !!items.length ? /*#__PURE__*/_react["default"].createElement(_List["default"], null) : /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      className: _defaultsModule["default"]['text-align']
    }, "\u041D\u0435\u0442 \u043D\u043E\u0432\u044B\u0445 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439")), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['control']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultsModule["default"]['apply-button'],
      onClick: function onClick() {
        return handleViewAll();
      }
    }, "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

Notifications.defaultProps = {
  onViewAll: null
};
var _default = Notifications;
exports["default"] = _default;